import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import userSlice from "../features/user/userSlice";
import drawerSlice from "../components/drawer/drawerSlice";
import menuSlice from "../features/menu/menuSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import inquirySlice from "../features/inquiry/inquirySlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import faqSlice from "../features/faq/faqSlice";
import bannerSlice from "../features/banner/bannerSlice";
import rightsSlice from "../features/rights/rightsSlice";
import loginSlice from "../features/login/loginSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import facilitySlice from "../features/facility/facilitySlice";
import whychooseSlice from "../features/whychoose/whychooseSlice";
import amenitiesSlice from "../features/amenities/amenitiesSlice";
import tourtypeSlice from "../features/tourtype/tourtypeSlice";
import activitySlice from "../features/activities/activitiesSlice";
import gallerySlice from "../features/gallery/gallerySlice";
import roomSlice from "../features/room/roomSlice";
import signatureMomentSlice from "../features/signaturemoment/signatureMomentSlice";
import experienceSlice from "../features/experience/experienceSlice";
import philosophySlice from "../features/philosophy/philosophySlice";
import weddingVenueSlice from "../features/weddingvenue/weddingVenueSlice";
import idealSlice from "../features/ideal/idealSlice";
import attractionsSlice from "../features/attraction/attractionsSlice";
import newsletterSlice from "../features/newsletter/newsletterSlice";
import packageSlice from "../features/package/packageSlice";
import bookingReferenceSlice from "../features/bookingReference/bookingReferenceSlice";
import positionSlice from "../features/position/positionSlice";
import jobapplicationSlice from "../features/jobapplication/jobapplicationSlice";
import videoGallerySlice from "../features/videogallery/videoGallerySlice";
import popupSlice from "../features/popup/popupSlice";
import diningSlice from "../features/dining/diningSlice";
import eventspaceSlice from "../features/eventspace/eventspaceSlice";
import gallerytypeSlice from "../features/gallerytype/gallerytypeSlice";
import offerSlice from "../features/offer/offerSlice";
import eventSlice from "../features/event/eventSlice";
import passwordSlice from "../features/ChangePassword/changePasswordSlice";

const store = configureStore({
  reducer: {
    password: passwordSlice,
    dialog: dialogSlice,
    drawer: drawerSlice,
    user: userSlice,
    menu: menuSlice,
    userType: userTypeSlice,
    inquiry: inquirySlice,
    cms: cmsSlice,
    banner: bannerSlice,
    faq: faqSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    seotag: seotagSlice,
    rights: rightsSlice,
    login: loginSlice,
    pagination: paginationSlice,
    setting: settingSlice,
    facility: facilitySlice,
    whychoose: whychooseSlice,
    amenities: amenitiesSlice,
    tourtype: tourtypeSlice,
    activity: activitySlice,
    gallery: gallerySlice,
    room: roomSlice,
    signatureMoment: signatureMomentSlice,
    experience: experienceSlice,
    philosophy: philosophySlice,
    weddingVenue: weddingVenueSlice,
    ideal: idealSlice,
    attractions: attractionsSlice,
    newsletter: newsletterSlice,
    package: packageSlice,
    bookingReference: bookingReferenceSlice,
    position: positionSlice,
    jobapplication: jobapplicationSlice,
    videoGallery: videoGallerySlice,
    popup: popupSlice,
    dining: diningSlice,
    eventspace: eventspaceSlice,
    gallerytype: gallerytypeSlice,
    offer: offerSlice,
    event: eventSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
